import "dayjs/locale/zh-cn";
import "dayjs/locale/zh-tw";
import "dayjs/locale/en";
import "dayjs/locale/ja"
import i18nConsumerY from "@charmdeer/i18n/lib/distributions/ysys-web/consumer-y";
import epEn from "element-plus/dist/locale/en.mjs";
import epZhCn from "element-plus/dist/locale/zh-cn.mjs";
import epZhTw from "element-plus/dist/locale/zh-tw.mjs";
import jp from "element-plus/dist/locale/ja.mjs"
import { merge } from "lodash";

import { localesConfigs as hotelLocales } from "@/packages/hotel/locales";
import { localesConfigs as limoLocales } from "@/packages/limo/locales";
import { updateMessages } from "@/plugins/i18n";
import { useUserStoreHook } from "@/store/modules/user";

export const initLocale = async () => {
  // 默认英文
  await updateMessages(useUserStoreHook().language, {
    en: {
      ...i18nConsumerY.locales.en,
      ...merge(hotelLocales.en, limoLocales.en)
    },
    zh: {
      ...i18nConsumerY.locales.zh,
      ...merge(hotelLocales.zh, limoLocales.zh)
    },
    zh_TW: {
      ...i18nConsumerY.locales.zh_TW,
      ...merge(hotelLocales.zh_TW, limoLocales.zh_TW)
    },
    jp: {
      ...i18nConsumerY.locales.jp,
      ...merge(hotelLocales.jp, limoLocales.jp)
    }
  });
};
/** element-plus 多语言 */
export const elementPlusLocales = {
  zh: epZhCn,
  zh_TW: epZhTw,
  en: epEn,
  jp: jp
};

/**
 * 获取 element-plus 当前语言文件
 * @returns
 */
export const getElementPlusLocale = locale => {
  return elementPlusLocales[locale];
};
